import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BackButton } from '@/components/BackButton';
import { GrowthCalculator } from './GrowthCalculator';
import s from './index.module.scss';

export const CalculatorPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('calculator');
  return (
    <div className={s.page}>
      <div className="container-inner">
        <BackButton onClick={() => navigate(-1)} />
        <div className={s.header}>
          <h1 className={s.title}>{t('title')}</h1>
          <p className={s.desc}>
            {t('growth.unlock_the_power_of_compounding')}
          </p>
        </div>
        <div className={s.calculator}>
          <h2 className="f-hero-h5">
            {t('growth.simulate_your_long_term_growth')}
          </h2>
          <GrowthCalculator />
        </div>
      </div>
    </div>
  );
};

export default CalculatorPage;